import {
    SET_PLAYING_VIDEO_W, SET_PENDING_WORKOUT, SET_NEXT_WORKOUTS, SET_TRENDING_WORKOUT, SET_WEEK_WORKOUTS,
    SET_GROUPED_WORKOUTS, SET_CURRENT_WATCHED,
} from "./types";
import { SET_PROGRAM } from "../program/types";
import { apiCallV2, servicesAPICall } from "../../../utils/api";
import { getAge } from "../../../utils/date";
import { programLevels } from "../../../constants";
import toast from "react-hot-toast";


const getNextWorkouts = async (workout, dispatch) => {

    dispatch({
        type: SET_NEXT_WORKOUTS,
        data: null
    })

    const res2 = await apiCallV2(
        "GET",
        "get-workouts",
        "",
        localStorage.getItem("access-token"),
        { program_id: workout.program_id, program_detail_id: workout.program_detail_id }
    );

    dispatch({
        type: SET_NEXT_WORKOUTS,
        data: [...res2.data.data.workouts]
    })
}

export const Watching = () => async (dispatch, getState) => {
    dispatch({
        type: SET_CURRENT_WATCHED,
    })
}

export const SetWorkout = (id) => async (dispatch, getState) => {
    const { programs } = getState().Program;
    const res = await apiCallV2(
        "GET",
        "get-workouts",
        "",
        localStorage.getItem("access-token"),
        { id: id }
    );

    let workout = { ...res.data.data.workouts[0] };
    let program = programs.filter(p => p.id === workout.program_id)[0]

    if (res.status === 200) {
        getNextWorkouts(workout, dispatch);

        dispatch({
            type: SET_PROGRAM,
            data: { ...program }
        })

        dispatch({
            type: SET_PENDING_WORKOUT,
            data: workout
        })
        return { isLoaded: true, workout: workout };
    } else {
        return { isLoaded: false };
    }
}

export const SaveWorkoutWatchedtime = (data) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "save-workout-watchedtime",
        {
            videoID: data.id,
            time: data.time,
            percentage: data.percentage,
        },
        localStorage.getItem("access-token")
    );


    // dispatch({
    //     type: SET_FAVORITE_EXERCISES,
    //     list: [...favorites.data.favorites]
    // })
}

export const GetWorkoutWatchedTime = (videoID) => async (dispatch, getState) => {

    const { playing } = getState().Workout;
    let tempPlaying = { ...playing };


    const res = await apiCallV2(
        "GET",
        "get-workout-watchedtime",
        "",
        localStorage.getItem("access-token"),
        {
            videoID: videoID
        },
    );



    tempPlaying = {
        ...tempPlaying,
        ["video-id-" + videoID]: res.data.data.time
    }

    dispatch({
        type: SET_PLAYING_VIDEO_W,
        data: { ...tempPlaying }
    })

}

export const GetPendingWorkout = (filter = null) => async (dispatch, getState) => {
    const { } = getState().Workout;

    const res = await apiCallV2(
        "GET",
        "get-pending-workout",
        "",
        localStorage.getItem("access-token"),
        filter
    );

    if (res && res.status == 200) {
        dispatch({
            type: SET_PENDING_WORKOUT,
            data: { ...res.data.workout }
        })

        getNextWorkouts(res.data.workout, dispatch);

        return true;
    } else {
        return false;
    }
}

export const GetTrendingWorkout = (videoID) => async (dispatch, getState) => {
    const { } = getState().Workout;

    const res = await apiCallV2(
        "GET",
        "get-trending-workout",
        "",
        localStorage.getItem("access-token"),
    );


    if (res.status === 200) {
        dispatch({
            type: SET_TRENDING_WORKOUT,
            data: [...res.data.data.workouts]
        })
    }
}

export const GetWholeWeekWorkout = (week, program, level) => async (dispatch, getState) => {
    const { } = getState().Workout;

    const res = await apiCallV2(
        "GET",
        "get-workouts",
        "",
        localStorage.getItem("access-token"),
        { program_id: program, program_detail_id: level }
    );


    if (res.status === 200) {
        dispatch({
            type: SET_WEEK_WORKOUTS,
            data: [...res.data.data.workouts]
        })
        return true;
    } else {
        return false;
    }
}

export const GetWholeLevelWorkout = (program, level, week = 1) => async (dispatch, getState) => {
    const { pendingWorkout } = getState().Workout;

    const res = await apiCallV2(
        "GET",
        "get-workouts",
        "",
        localStorage.getItem("access-token"),
        { program_id: program, program_detail_id: level }
    );


    if (res.status === 200) {
        dispatch({
            type: SET_WEEK_WORKOUTS,
            data: [...res.data.data.workouts]
        })

        if (!pendingWorkout) {
            dispatch({
                type: SET_PENDING_WORKOUT,
                data: { ...res.data.data.workouts[0] }
            })
        }

        dispatch({
            type: SET_NEXT_WORKOUTS,
            data: [...res.data.data.workouts]
        })

        return true;
    } else {
        return false;
    }

}

export const SetSelectedWorkout = (video) => async (dispatch, getState) => {
    dispatch({
        type: SET_PENDING_WORKOUT,
        data: { ...video }
    })
}

export const GetWholeWorkoutByProgram = (program, level = 0, isGroup = false) => async (dispatch, getState) => {

    dispatch({
        type: SET_NEXT_WORKOUTS,
        data: []
    })

    const { pendingWorkout, groupedWorkouts } = getState().Workout;

    const type = "prog-" + program + (level ? ("-" + level) : "");
    let status = 0;
    let workouts = [];
    let newGroupedWorkouts = { ...groupedWorkouts };

    if (groupedWorkouts.hasOwnProperty(type)) {
        workouts = [...groupedWorkouts[type]];
        status = 200;
    } else {
        const res = await apiCallV2(
            "GET",
            "get-workouts",
            "",
            localStorage.getItem("access-token") || localStorage.getItem("temp-access-token"),
            { program_id: program, program_detail_id: level }
        );

        status = res.status;

        workouts = res?.data?.data?.workouts ? [...res?.data?.data?.workouts] : [];

        newGroupedWorkouts[type] = [...workouts]

    }


    if (status === 200) {
        dispatch({
            type: SET_NEXT_WORKOUTS,
            data: workouts
        })

        dispatch({
            type: SET_GROUPED_WORKOUTS,
            data: newGroupedWorkouts
        })

        return workouts;
    } else {
        return false;
    }

}

export const SendPostWorkoutNotification = () => async (dispatch, getState) => {
    const { programs } = getState().Program;
    const { workoutHistory, user } = getState().User;
    const { pendingWorkout } = getState().Workout;

    // if (workoutHistory && workoutHistory.length == 1) {
    let programTemp = programs.filter(p => p.id == pendingWorkout?.program_id);
    const genderValueRev = {
        "M": "Male",
        "F": "Female",
        "O": "",
        "GNL": "",
        "PNTS": "",
    };

    const payload = {
        id: user?.id,
        firstName: user?.first_name,
        lastName: user?.last_name,
        gender: genderValueRev[user?.gender],
        age: getAge(new Date(user?.dob)),
        program: `${programTemp[0]?.title} ${programLevels[pendingWorkout?.program_detail_id]}`?.trim(" ")?.toLowerCase(),
        workoutDetail: {
            ...pendingWorkout
        },
        numberOfWorkouts: workoutHistory.length,
    }

    const res = await servicesAPICall(
        "POST",
        "notification/post-workout-notification",
        {
            ...payload
        },
        localStorage.getItem("access-token")
    );
    // } 

}

export const SubmitPostWorkoutRating = (rating, feedback, workoutID) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "add-post-workout-rating",
        {
            rating: rating,
            comment: feedback,
            workoutID: workoutID,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200 && res?.data?.status == 200) {
        return true;
    } else {
        return false;
    }

}

export const GetWorkoutDetails = (id) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "GET",
        "get-workout-detail",
        "",
        localStorage.getItem("access-token"),
        { workoutID: id }
    );

    return res?.data?.data?.[0] || null;

}